import Swiper from 'swiper';

class HomeSlider {

  constructor(){
    this.component = document.querySelector('[data-component="home-slider"]');
    this.trigger = document.querySelector('[data-trigger="home-slider"]'); 
    this.buttonTrigger = document.querySelectorAll('[data-trigger="slide"]');

    if( this.component ){
      this._init();
    }
  }

  _init(){

    this.swiper = new Swiper(this.trigger, {
      loop: true,
      effect: 'fade',
      speed: 800,
      navigation: {
        nextEl: this.component.querySelector('[data-trigger="home-slider-next"]'),
        prevEl: this.component.querySelector('[data-trigger="home-slider-prev"]'),
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: this.component.querySelector('[data-trigger="home-slider-pagination"]'),
        clickable: true,
      },
      preloadImages: false,
      lazy: {
        loadOnTransitionStart: true,
      },
    }); 

    this.swiper.on('slideChange', () => {

      let index = 1;

      if (this.swiper.activeIndex <= this.buttonTrigger.length) {
        index = this.swiper.activeIndex;
      }

      this.component.setAttribute('data-slide', index);
      
    });

    const firstImage = this.trigger.querySelector('img');
    if(firstImage){
      firstImage.onload = ()=> {
        if(this.swiper){
          this.swiper.update();
        }
      };
    }

    for (let i = 0; i < this.buttonTrigger.length; i++) {
      const element = this.buttonTrigger[i];
      element.addEventListener('click', (e)=> {
        this.handleClick(e);
      }); 
    }
  }


  handleClick(e) {
    let index = e.target.getAttribute('data-id');
    this.component.setAttribute('data-slide', index);
    this.swiper.slideTo(index);
  }
}

export const homeSlider = new HomeSlider();